import React, { useRef, useEffect, Fragment } from "react";
import clsx from "clsx";
import { useSelector } from "react-redux";
import TYPE from "../../../../../../../constant/TYPE";
import Grammar from "./grammar/Grammar";

const Question = ( props ) => {

  const learningBody = useRef();

  const deviceInfo = useSelector( state => state.deviceInfo );
  const answeringQuestions = useSelector( state => state.answeringQuestions );

  useEffect( () => {
    answeringQuestions.data.qstCd && learningBody.current.scrollTo( { top : 0, left : 0 } );
  }, [ answeringQuestions.data.qstCd ] );

  const {
    GrammarReducer,
    children,
    ...PROPS
  } = props;

  return (
    <div 
      className={
        clsx(
          'learning_body', 
          deviceInfo.type && TYPE.DEVICE.PC !== deviceInfo.type && answeringQuestions.isShowKeypad && 'with_key'
        ) 
      } 
      ref={ learningBody }
    >
      <GrammarReducer><Grammar { ...PROPS } /></GrammarReducer>
    </div>
  );

};

Question.defaultProps = {
  GrammarReducer : Fragment
};

export default Question;
